module.exports = "/images/wifi-icon.svg?cd9e4a3368db66f254ba82104fd83bd1";